<template>
  <!-- Definisce un elemento per la visualizzazione di video tutorial contestuali ad un determinato       -->
  <!-- argomento. I video tutorial da poter riprodurre sono elencati passando alla relativa prop          -->
  <!-- lo slugname del tutorial di interesse ( vedi per info sugli slug name l'app staticlinks di django ). -->

  <!-- L'elemento viene mostrato solo se vengono trovati i video -->
  <div v-if="video_list.length > 0">
    <b-alert variant="success" class="text-center" show dismissible>
      <b-img :src="doubt_man_icon" fluid alt="doubt man" class="mr-2"></b-img>
      <span class="h6">{{ info_text }}</span>
      <!-- Se il video è solo uno faccio apparire solo il bottone, se più di uno -->
      <!-- renderizzo invece la drop down -->
      <!-- BOTTONE: Per un solo video. -->
      <b-button v-if="video_list.length == 1" pill size="sm" class="m-2" variant="primary"
                @click.prevent="play_video($event, video_list[0].url, video_list[0].descrizione )">
        Guarda <b-icon icon="play-fill"></b-icon>
      </b-button>
      <!-- PULSANTE DROP DOWN: contiene la lista dei video da poter riprodurre se più di uno -->
      <!-- La classe dropdown-pill è definita sotto e rende il pulsante arrotondato per      -->
      <!-- allinearlo al pill del pulsante singolo -->
      <b-dropdown v-else right size="sm" text="Guarda" class="m-2 dropdown-pill" variant="primary">
        <b-dropdown-item-button v-for="video in video_list" :key="video.id"
          @click.prevent="play_video($event, video.url, video.descrizione )">
          <b-icon icon="play-fill" variant="primary"></b-icon> {{video.nome}}
        </b-dropdown-item-button>
      </b-dropdown>
    </b-alert>
    <!-- MODALE: Dentro vi è l'elemento b-embed per la visualizzazione del video -->
    <b-modal v-model="video_player.show_modal" size="xl" :title="video_player.video_title">
      <b-embed
          type="iframe"
          aspect="4by3"
          :src="video_player.video_url"
          allowfullscreen
      ></b-embed>
      <template v-slot:modal-footer="{ cancel }">
          <b-button variant="primary" size="sm" class="float-right" @click="cancel()">
              Chiudi
          </b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'TutorialContestuale',
  data () {
    return {

      // Lista dei video che si possono mostrare
      video_list : [],

      // Elementi per la modale e per l'elemento b-embed
      // per la visualizzaizone dei tutorial
      video_player : {
        show_modal : false,
        video_title : null,
        video_url : null
      },

      // Icona dell'uomo dubbioso
      doubt_man_icon : require('@/assets/icons/doubt_man.png')

    }
  },
  computed: {
    /**
     * Si tratta di una finezza, adatta l'info testo a seconda degli
     * elementi presenti nella lista dei video da vedere.
     */
    info_text : function () {
      let info_text = "Non sai come fare? Guarda prima il video tutorial!"
      if ( this.video_list.length > 1 ) {
        info_text = info_text.replace( 'il', 'i' );
      }
      return info_text;
    }
  },
  methods : {
    /**
     * Visualizza il video del tutorial all'interno della modale
     */
    play_video : function ( event, url, descrizione ) {
      this.video_player.video_url = url;
      this.video_player.video_title = descrizione;
      this.video_player.show_modal = true;
    }
  },
  created : function () {

    /**
     * Alla creazione dell'elemento prendiamo la lista dei tutorial e filtriamo
     * solo quelli di interesse.
     */
    let api_url = apiUrl.staticlinks.list_links.replace( '@ltype', 'tutorial' );
    axios.get( api_url )
    .then( ( response ) => {

      for ( let elem of response.data ) {
        // Prendiamo la lista dei link che fanno parte di un gruppo
        // e quindi prendiamo solo quelli richiesti per la visualizzazione
        // nel tutorial contestuali elencati nella property video_to_show
        let link_list = elem.link;
        for ( let link of link_list ) {
          if ( this.video_to_show.indexOf( link.slug_name ) != -1 ){
            this.video_list.push( link );
          }
        }
      }

    })
    .catch( ( error ) => {
      generalLib.backend_error_message_box( this, error.response.data );
    });

  },
  props : {
    /**
     * Lista dei video che questo elemento deve poter riprodurre.
     * L'array deve contenere gli slug_name dei video di interesse,
     * e solo quelli saranno mostrati.
     */
    video_to_show : {
      type: Array,
      required : true
    }
  }
}
</script>



<style scoped>
.dropdown-pill :deep( .btn ) {
  border-radius: 20px;
}
</style>